<div class="gojs-palette-container hidden">
  <div id="myPaletteDiv" #palette class="gojs-palette"></div>
</div>
<div class="gojs-diagram-container">
  <div id="myDiagramDiv" #diagram class="gojs-diagram"></div>
  <div class="gojs-legend">
    <span class="checkbox">
      <input type="checkbox" id="showLinkLabels" class="no-margin show-for-sr" (ngModelChange)="hideShowLinkLabels($event);" [(ngModel)]="showLabels" />
      <label for="showLinkLabels">
        <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
        Link Labels
      </label>
    </span>
  </div>
</div>
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
